module.exports = __webpack_public_path__ + "static/media/Brands_12.0568aeef.png";